import styled from 'styled-components';

export const AsideInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  gap: 8px;

  & + & {
    border-top: 2px solid ${({ theme }) => theme.colors.darkerBackground};
  }
`;
